import HoldingClassModal from 'modules/_shared/components/Modals/HoldingClass';

export default [
  {
    icon: 'ni-book-read',
    text: 'Nueva Clase',
    url: HoldingClassModal,
  },
];
